export function downloadInvoice()
{
    return({
        type:"DOWNLOAD_INVOICE"
    })
}